import React, { useState, useEffect, useMemo } from 'react';
import { Footer, Header } from './headerFooter';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import { useNavigate } from 'react-router-dom';
import { EIDIKI_TABLE_OPTIONS_D, EIDIKI_TABLE_OPTIONS } from './constants';
import { getHost } from './config';
import FilterSidebar from './FilterSidebar';
import {
    initialSidebarOpen,
    collapseFilterSidebarOnMobile,
    formatYearRangeLabel,
    joinFilterSummaryParts,
} from './filterSidebarUtils';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./custom.scss";

function RankingAboveMe() {
    const [data, setData] = useState(null);
    const [uniqueDates, setUniqueDates] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState('');
    const [selectedValue, setSelectedValue] = useState(''); // State for user-entered value
    const [uniqueLocations, setUniqueLocations] = useState([]);
    const [submitted, setSubmitted] = useState(false); // State to track if form submitted
    const [isValidInput, setIsValidInput] = useState(true);
    const [yearRange, setYearRange] = useState(''); // New state for year range
    const [specialty, setSpecialty] = useState(''); // New state for specialty
    const [specialtyOptions, setSpecialtyOptions] = useState([]); // Options for specialty dropdown
    const [specialtyLoading, setSpecialtyLoading] = useState(false); // Loading state for specialty fetch
    const [locationsLoading, setLocationsLoading] = useState(false); // Loading state for locations fetch
    const [loading, setLoading] = useState(false); // New loading state
    const [eidikiAgogi, setEidikiAgogi] = useState('false');
    const [eidikiAgogiTableType, setEidikiAgogiTableType] = useState('')
    const [sidebarOpen, setSidebarOpen] = useState(initialSidebarOpen);
    const navigate = useNavigate();
    const token = localStorage.getItem('authToken');

    useEffect(() => {
        if (!token) {
            navigate('/', { replace: true });
        }
    }, [token, navigate]);

    useEffect(() => {
        if (yearRange && specialty) {
            setLocationsLoading(true);
            const url = `${getHost()}/api/places?year_range=${yearRange}&specialty=${specialty}`;
            fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            })
                .then(response => response.json())
                .then(data => {
                    console.log('API Data:', data);
                    setData(data.results);
                    const locations = new Set();
                    data.results.forEach(location => {
                        locations.add(location);
                    });
                    setUniqueLocations(Array.from(locations).sort());
                    console.log(setUniqueLocations)
                })
                .catch(error => console.error('Error fetching data:', error))
                .finally(() => setLocationsLoading(false));
        } else {
            setUniqueLocations([]); // Clear specialties when yearRange is not selected
        }
    }, [yearRange, specialty]);

     // Fetch specialties based on the selected year_range
     useEffect(() => {
        if (yearRange) { // Fetch only if yearRange is selected
            setSpecialtyLoading(true);
            const url = `${getHost()}/api/specialty-types?year_range=${yearRange}`;
            fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            })
                .then(response => response.json())
                .then(data => setSpecialtyOptions(data.results))
                .catch(error => console.error('Error fetching specialties:', error))
                .finally(() => setSpecialtyLoading(false));
        } else {
            setSpecialtyOptions([]); // Clear specialties when yearRange is not selected
        }
    }, [yearRange]);


    const handleValueChange = (event) => {
        const rawValue = event.target.value;
        const value = rawValue.trimEnd();
        setSelectedValue(value);
        // Regular expression to match only integers
        const isValid = /^\d+$/.test(value);
        setIsValidInput(isValid);
    };

    const handleSubmit = () => {
        setLoading(true);
        // Send POST request with selected value and selected date
        if (selectedValue !== '' && selectedDate !== '') {
            const url = `${getHost()}/api/place-ranking`
            const requestBody = {
                ranking: selectedValue,
                place: selectedLocation,
                year_range: yearRange,
                specialty: specialty,
                eidiki_agogi: eidikiAgogi === 'true', 
                eidiki_agogi_table_type: eidikiAgogiTableType
            }
            console.log(requestBody)
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(requestBody),
            })
                .then(response => response.json())
                .then(data => {
                    // Handle response data
                    console.log(data);
                    setData(data.results);
                    const dates2 = new Set();
                    data.results.forEach(dateData2 => {
                        Object.keys(dateData2).forEach(date2 => {
                            dates2.add(date2);
                        });
                    });
                    setSubmitted(true);
                    collapseFilterSidebarOnMobile(setSidebarOpen);
                })
                .catch(error => console.error('Error sending POST request:', error))
                .finally(() => {
                    setLoading(false); // Hide loading indicator regardless of success/failure
                });
        }
    };

    const handleLogout = () => {
        // Clear the authToken from localStorage
        localStorage.removeItem('authToken');
        localStorage.setItem('logout-event', Date.now());

        // Redirect to the login page
        navigate('/', { replace: true });
    };

    const isFormValid = yearRange !== '' && specialty !== '' && selectedValue !== '' && selectedLocation !=='' && (eidikiAgogi === "false" || (eidikiAgogi === "true" && eidikiAgogiTableType));

    const filterSummary = useMemo(
        () => joinFilterSummaryParts([
            formatYearRangeLabel(yearRange),
            specialty,
            selectedValue ? `θέση ${selectedValue}` : '',
            selectedLocation,
        ]),
        [yearRange, specialty, selectedValue, selectedLocation]
    );

    return (
        <div id="root">
            <Header handleLogout={handleLogout}/>
            <main className='main-container ranking-per-state-page'>
                <FilterSidebar
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    filterSummary={filterSummary}
                    bodyId="people-above-me-sidebar-body"
                >
                        <Form>
                    <Form.Group className="mb-3" controlId="yearSelect.range">
                        <Form.Label className='custom-label'>Έτος:</Form.Label>
                        <Form.Select 
                            className="custom-form" 
                            value={yearRange} 
                            onChange={(e) => {
                                setYearRange(e.target.value);
                                setSpecialty("");
                                setSelectedValue("");
                                setSelectedLocation("");
                                setSubmitted("");
                                setData("");
                            }}>
                            <option>Επιλέξτε...</option>
                            <option value="2022_2023">2022-2023</option>
                            <option value="2023_2024">2023-2024</option>
                            <option value="2024_2025">2024-2025</option>
                            <option value="2025_2026">2025-2026</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="yearSelect.specialty">
                        <Form.Label className='custom-label'>Ειδικότητα:</Form.Label>
                        <Form.Select 
                            className="custom-form" 
                            value={specialty} 
                            onChange={(e) => {
                                setSpecialty(e.target.value);
                                setSelectedLocation("");
                                setData("");
                                setSubmitted("");
                            }} 
                            disabled={!yearRange || specialtyLoading}>
                            <option>{specialtyLoading ? 'Φόρτωση...' : 'Επιλέξτε...'}</option>
                            {!specialtyLoading && (specialtyOptions.length > 0 ? (
                                specialtyOptions
                                .slice() // Shallow copy
                                .sort((a, b) => a.localeCompare(b)) // Sort alphabetically
                                .map((spec) => (
                                    <option key={spec} value={spec}>
                                        {spec}
                                    </option>
                                ))
                            ) : (
                                <option>No specialties available</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className='custom-label'>Θέση πίνακα:</Form.Label>
                        <Form.Control className="custom-form" type="text" placeholder="Εισάγετε την θέση σας στον πίνακα" value={selectedValue} onChange={handleValueChange} />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="yearSelect.location">
                        <Form.Label className='custom-label'>Τοποθεσία προτίμησης:</Form.Label>
                        <Form.Select className="custom-form" value={selectedLocation} onChange={(e) => setSelectedLocation(e.target.value)} disabled={locationsLoading}>
                            <option>{locationsLoading ? 'Φόρτωση...' : 'Επιλέξτε τοποθεσία προτίμησης...'}</option>
                            {!locationsLoading && uniqueLocations.map(location => (
                                        <option key={location} value={location}>{location}</option>
                                    ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="yearSelect.eidiki">
                            <Form.Label className='custom-label'>Ειδική Αγωγή:</Form.Label>
                            <Form.Select 
                                className="custom-form" 
                                value={eidikiAgogi} 
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setEidikiAgogi(value);
                                    setData("");
                                    if (value === "false") {
                                        setEidikiAgogiTableType(EIDIKI_TABLE_OPTIONS[0]?.value || "");
                                    }
                                }}>
                                <option value="false">Όχι</option>
                                <option value="true">Ναι</option>
                            </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className='custom-label'>Είδος πίνακα:</Form.Label>
                        <Form.Select 
                            className="custom-form" 
                            name="table_value" 
                            value={eidikiAgogiTableType} 
                            onChange={(e) => { 
                                setEidikiAgogiTableType(e.target.value);
                                setData("");
                            }} 
                            required
                            disabled={eidikiAgogi === "false"}
                            >
                            <option value="">Επιλέξτε πίνακα</option>
                            {EIDIKI_TABLE_OPTIONS.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option> ))}
                        </Form.Select>
                    </Form.Group>
                        </Form>
                        <p className="ranking-per-state-sidebar-note text-muted fst-italic small">
                            * <strong>Διευκρίνιση: </strong>Ο εκπαιδευτικός θα πρέπει να εισάγει τη θέση βάσει του αρχικού πίνακα και όχι των εκκαθαρισμένων.
                        </p>
                        <div className="d-flex justify-content-center mt-3 mb-4">
                            <Button
                                variant="secondary"
                                type="button"
                                className="predict-submit-button"
                                onClick={handleSubmit}
                                disabled={!isFormValid}
                            >
                                Υποβολή
                            </Button>
                        </div>
                </FilterSidebar>
                <div className={`ranking-per-state-main ${!sidebarOpen ? 'ranking-per-state-main--sidebar-collapsed' : ''}`}>
                    <Container fluid className="ranking-per-state-container">
                        <Row className="g-3 g-md-4">
                            <Col xs={12}>
                                <div className="ranking-per-state-content">
                                {!submitted && !data && !loading && (
                                    <p className="text-muted small mb-2">
                                        Ο εκπαιδευτικός εισάγει τη <strong>σχολική χρονιά</strong> που τον ενδιαφέρει, την <strong>ειδικότητά</strong> του, τη <strong>θέση</strong> του στον αρχικό πίνακα (όχι εκκαθαρισμένο), την <strong>περιοχή προτίμησής</strong> και αν αναφέρεται στον πίνακα <strong>ειδικής αγωγής</strong> ή όχι.<br />
                                Ενημερώνεται για όλες τις φάσεις πρόσληψης σχετικά με τον συνολικό αριθμό προσλήψεων καθώς και για τον αριθμό των ατόμων που προηγούνται.<br />
                                <strong>Παράδειγμα αποτελέσματος: </strong><br />
                                Έστω ότι ο εκπαιδευτικός εισάγει: 2023-2024, ΠΕ02, 1500, Α' ΕΒΡΟΥ (Δ.Ε.), Ειδική αγωγή: ΟΧΙ<br />
                                Το αποτέλεσμα που προκύπτει είναι το παρακάτω:
                                <ul>
                                    <li>2023-09-01</li>
                                    <li>Άτομα πριν από μένα: 14</li>
                                    <li>Συνολικές προσλήψεις: 23</li>
                                </ul>
                                Άρα, κατά την φάση προσλήψεων που έγινε στις 01/09/2023 προσλήφθηκαν 23 άτομα στην γενική από τα οποία τα 14 είχαν καλύτερη θέση από τον ενδιαφερόμενο εκπαιδευτικό.
                                    </p>
                                )}
                                {loading && (
                                    <div className="text-center mt-3 mb-3">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <div>Φόρτωση αποτελεσμάτων...</div>
                                    </div>
                                )}

                                {submitted && data ? (
                                    <div className={!sidebarOpen ? 'results-snug-mobile' : ''}>
                                        <div className="data-container">
                                            {data.map((locationData2, index) => (
                                                <React.Fragment key={index}>
                                                    {Object.entries(locationData2).map(([location, info]) => (
                                                        <Card className='custom-card' key={location}>
                                                            <Card.Body>
                                                                <Card.Title>{location}</Card.Title>
                                                                <ListGroup className="list-group-flush">
                                                                    <ListGroup.Item>Άτομα πριν από μένα: {info.total_smaller}</ListGroup.Item>
                                                                    <ListGroup.Item>Συνολικές προσλήψεις: {info.total}</ListGroup.Item>
                                                                </ListGroup>
                                                            </Card.Body>
                                                        </Card>
                                                    ))}
                                                </React.Fragment>
                                            ))}
                                        </div>
                                    </div>
                                ) : !loading && null}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default RankingAboveMe;
